<script setup>
import {changeStep, Steps} from "@/composables/ai-onboarding/useSteps";
import NavigationButtons from "@/components/ai-onboarding/partials/NavigationButtons.vue";
import AccountBox from "@/components/ai-onboarding/partials/AccountBox.vue";
import {useStore} from "vuex";
import {computed, onMounted} from "vue";
import {useMutation} from "@tanstack/vue-query";
import axios from "axios";

const emit = defineEmits(['changeStep']);

const store = useStore();

const analytics = computed(() => store.getters['onboarding/analytics']);
const searchConsole = computed(() => store.getters['onboarding/searchConsole']);
const businessProfile = computed(() => store.getters['onboarding/businessProfile']);

onMounted(async () => await store.dispatch('onboarding/fetchConnectedAccounts'));

const {mutate: handleNext, isPending: loading} = useMutation({
  mutationFn: async () => await axios.get('/ajax/v2/ai-onboarding/trigger-keyword-selection'),
  onSuccess: () => {
    changeStep(Steps.HOLDING, emit)
  },
  onError: () => {
    throw new Error('Something went wrong');
  },
});
</script>

<template>
  <div class="tw-flex tw-flex-col tw-w-full tw-justify-between tw-h-full">
    <div class="tw-text-center tw-p-18 tw-overflow-y-auto">
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-y-6">
        <div class="tw-flex tw-flex-col tw-gap-16 tw-items-center tw-w-full">
          <div class="tw-flex tw-flex-col tw-gap-6 tw-w-full">
            <AccountBox
              title="Google Analytics"
              :connected="!!analytics"
              icon="icons/google-analytics-4"
              connection-uri="/google/connect/Analytics/ai-onboarding?step=account"
            />

            <AccountBox
              title="Google Search Console"
              :connected="!!searchConsole"
              icon="icons/google-search-console"
              connection-uri="/google/connect/Console/ai-onboarding?step=account"
            />

            <AccountBox
              title="Google Business Profile"
              :connected="!!businessProfile"
              icon="icons/google-my-business-logo"
              connection-uri="/google/connect/Business/ai-onboarding?step=account"
            />
          </div>
        </div>
      </div>
    </div>

    <NavigationButtons
      :loading="loading"
      @back="changeStep(Steps.SERVICES_OFFERED, emit)"
      @next="handleNext"
    />
  </div>
</template>
